import { FetchError } from '@/connection/helpers';
import { GetProjectGroups } from '@/connection/projects/get-project-groups';
import { serializeError, getPayloadMessage, SerializedError } from '@/store/utils/serialize-error';
import { EventGroup } from '@/types/projects.types';
import { ProjectStateReducerCreator } from '../types';
import { RootState } from '@/store/root-state';

const loadProjectGroupsReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (channel: number, { rejectWithValue, getState }) => {
      try {
        const state = getState() as RootState;
        const projectGroups = state.project?.projectGroups as EventGroup[] | null;
        if (projectGroups) return projectGroups;

        const result = await GetProjectGroups({ channel, templatesOnly: true });
        if ('error' in result) {
          console.error('loadProjectGroups error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return result || [];
      } catch (error) {
        console.error(error);
        if (error instanceof FetchError) {
          return rejectWithValue(error.message);
        }

        throw error;
      }
    },
    {
      fulfilled: (state, action) => {
        state.projectGroups = action.payload;
      },
      pending: (state) => {
        state.projectGroups = null;
      },
      rejected: (state, action) => {
        state.projectGroups = null;
        console.error(action.payload || action.error);
        state.loadingWorkingProjectError =
          getPayloadMessage(action.payload as SerializedError | string | undefined) ||
          action.error?.message ||
          'Error loading project groups';
        state.loadingWorkingProject = false;
      },
    }
  );
};

export default loadProjectGroupsReducer;
